/** * @file InputRadio */
<template>
  <div :class="'radio-group-' + name">
    <el-radio
      v-for="(item, key) in choices"
      :label="item.value"
      :key="key"
      :name="name"
      v-model="inputRadioModel"
      @change="handleChange"
      :disabled="disabled"
    >
      {{ item.label }}
    </el-radio>
    <!-- <input type="text" :id="name" v-model="inputRadioModel" class="input_radio"> -->
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: null
    },
    choices: {
      type: Array,
      default: () => []
    },
    inputRadioVal: {
      type: [String, Number],
      default: null
    },
    handleChange: {
      type: Function,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    inputRadioModel: {
      get() {
        return this.inputRadioVal
      },
      set(val) {
        this.$emit('update:inputRadioVal', val)
      }
    }
  }
}
</script>
<style lang="scss">
.input_radio {
  display: none;
}
</style>
